package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.icons.MapLocation
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.estimates.EstimatesScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_admin_estimate_list
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteEstimatesAdmin : RouteParameterTo

object RouterEstimatesAdmin : RouterNoParameters<RouteEstimatesAdmin>(RouteEstimatesAdmin::class) {
    override fun routeFrom(parameters: RouteEstimatesAdmin) = "/admin/estimates"

    @Composable
    override fun Show(parameters: RouteEstimatesAdmin) {
        RouteEstimatesAdminImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteEstimatesAdmin,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    /** Opens the list without removing the current screen (the map) from the stack, so that "back" returns to it. */
    fun navigateToKeepingBack() = NavigateTo(
        route = RouteEstimatesAdmin,
        stack = NavigateToStack(
            popBackStack = false,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    // The editor of an estimate belongs to this entry of the menu
    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) = routeParameterTo is RouteEstimatesAdmin ||
        routeParameterTo is RouteEstimateExistingAdmin ||
        routeParameterTo is RouteEstimateNewAdmin

    override fun isMatching(route: String) = route == "/admin/estimates"

    override fun navigateFrom(path: String) = RouteEstimatesAdmin
}

class RouteEstimatesAdminImpl : Route<RouteEstimatesAdmin>(
    route = "/admin/estimates",
    params = RouteEstimatesAdmin,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current
        val state by appModel.states.collectAsState()

        if (state.apiProvider?.apiAdmin == null) {
            LaunchedEffect(Unit) { appModel.leaveAdminRoute() }
            return
        }

        LaunchedEffect(Unit) {
            appModel.ensureAdminMode()
            appModel.markCurrentRoute(RouteEstimatesAdmin)
            onEntryIsActive(appModel, emptyList())
        }

        EstimatesScreen(
            Modifier.fillMaxSize(),
            mode = Mode.Admin,
        ) {
            appModel.show(RouterEstimateNewAdmin.navigateTo())
        }
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_admin_estimate_list,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.MapLocation,
                    onClick = { appModel.show(RouterMapAdmin.navigateToKeepingBack()) }
                )
            )
        )
    }
}
